// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wb8X0uMgsathfOVBW2JU{display:block;text-decoration:none}.Aaf7occoifIA7j748dCB{background-position:center;background-repeat:no-repeat;background-size:cover;border-bottom:3px solid #fa005a;box-sizing:border-box;height:100px;width:100px}.hwm1Dn0CbcJusuWJN3nw{background-color:rgba(255,255,255,.6)}.kK7gucx7VFws_4LkAPuC{background-color:rgba(30,12,27,.1)}.JsDeovxgTKwQR6bfD7Iz{font-size:12px;font-weight:400;line-height:1.25;margin-left:3px;max-width:85px}.VUJkcqAcWaC2K5vtqJRT{color:#ffc500}.KD1zBOINkyOfrBbUPKlW{color:#520044}.vqVtSk5vQXG2HnYLFtNv{display:flex;margin-top:7px}.Wbhpln5rXT0Krx4fv2S4{fill:#ffc500}.LF96Qm_LGyNc7PMIHBrC{fill:#520044}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `wb8X0uMgsathfOVBW2JU`,
	"imageContainer": `Aaf7occoifIA7j748dCB`,
	"imageContainerDark": `hwm1Dn0CbcJusuWJN3nw`,
	"imageContainerLight": `kK7gucx7VFws_4LkAPuC`,
	"name": `JsDeovxgTKwQR6bfD7Iz`,
	"nameColorDark": `VUJkcqAcWaC2K5vtqJRT`,
	"nameColorLight": `KD1zBOINkyOfrBbUPKlW`,
	"nameContainer": `vqVtSk5vQXG2HnYLFtNv`,
	"themeSvgDark": `Wbhpln5rXT0Krx4fv2S4`,
	"themeSvgLight": `LF96Qm_LGyNc7PMIHBrC`
};
export default ___CSS_LOADER_EXPORT___;
